export const editorialPages = {
  "/blog": {
    type: "journal", eyebrow: "THE DCAR JOURNAL", title: "Stories for", accent: "the road ahead.",
    description: "Car culture, buying perspectives and a closer look at life behind the wheel. A journal for people who enjoy the journey.",
  },
  "/careers": {
    type: "careers", eyebrow: "CAREERS AT DCAR", title: "Bring your drive.", accent: "Find your people.",
    description: "Great car experiences start with people. Help us make buying, selling and owning a car feel a little more human.",
  },
  "/insurance": {
    type: "insurance", eyebrow: "DCAR MOTOR INSURANCE", title: "Your car deserves", accent: "a considered plan.",
    description: "Buying your next car or planning a renewal? Start a conversation about motor insurance, your vehicle and the cover you want to understand.",
  },
  "/dealership-program": {
    type: "partners", eyebrow: "DCAR DEALERSHIP PROGRAM", title: "Build connections.", accent: "Move forward together.",
    description: "Bring your automotive expertise to a conversation about partnership. Explore how your dealership could connect with the DCAR marketplace.",
  },
};
